//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../no/Builder.js";
import "../Features/Features.ShipDesign.DrawingSheetBuilder.js";
import "../Features/Features.ShipDesign.DrawingTemplateBuilder.js";
import "../no/Features.js";
let d=[[[0,"ContainerParts",1,0],[0,"DrawingName",1,0],[1,"DrawingSheet",0,"Features.ShipDesign.DrawingSheetBuilder",0],[1,"DrawingTemplate",0,"Features.ShipDesign.DrawingTemplateBuilder",0],[0,"Index",1,0],[0,"Level",1,0],[0,"Orientation",1,0],[0,"OrientationObject",1,"ModelingView",0],[0,"PartsList",1,0],[0,"PartsListString",1,0],[0,"SheetScale",1,0],[0,"ShowList",1,0],[0,"Symbol",1,0],[0,"UpdateFlag",1,0],[0,"ViewTag",1,"Drawings.DraftingView",0]],[[["drawingSheet"],"UpdateDrawingSheet",{},1,0]],[]];
SPLM.Features.ShipDesign.AssemblyViewBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.AssemblyViewBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;